import type { IconAliases } from 'vuetify'
import { aliases as mdiAliases, mdi } from 'vuetify/iconsets/mdi'

const aliases: Partial<IconAliases> = {
  ...mdiAliases,
}

export const icons = {
  defaultSet: 'mdi',
  aliases,
  sets: {
    mdi,
  },
}
